/* bf26y-r52 (14 Oct 2026, round 52): Gloves PDP buy box.
   Loaded only on templates/product.softgrip-gloves.json (see snippets/bf26z-sitewide.liquid, R52 block).
   1. Mixed colours by default: on load each multi-item pack card (2 Pack, 3 Pack, 4 Pack) gets
      different in-stock colours, in swatch order, starting with the selected colour (Oat, Rose, Mint).
   2. Fast colour change: when a colour swatch is clicked, every per-item picker switches to that colour
      straight away, instead of waiting for Shrine's section re-render request (600 to 900 ms).
   How: each picker is updated the way Shrine's own picker handler does it (select value, data-selected-id,
   thumbnail, quantityBreaks.selectedVariants and formVariants, which Shrine's Add to cart reads), but
   without firing change events: every change event on this page costs 100 to 150 ms of other scripts.
   All glove colours share one price, so no price text is touched here.
   Shrine Pro has no per-item default variant setting, which is why this needs a script.
   Rollout (14 Oct 2026): now loaded on every PDP with a pack selector. The script only acts when the
   product has one option, more than one variant and one price for every variant (safe(qb) below);
   otherwise it does nothing and Shrine's own picker behaviour is kept (for example SoftClip, which has
   Colour and Size). It never changes prices.
   Rollback: remove the R52 block from snippets/bf26z-sitewide.liquid.
   r53 (15 Oct 2026, W2): on product pages the mixed colours are rendered by snippets/quantity-breaks.liquid (rk_mix), so
   mix() finds every select already right and only copies the ids into Shrine's selectedVariants / formVariants (Add to cart
   still sends the 3 colours). In mix() (sync), setItem() leaves the id and thumbnail alone when data-selected-id already
   matches, so the server image is never swapped for the same picture. follow() (swatch click) works as before.
   Landing pages and ?variant= links still get the mix after load.
   r55 (FX1, Q2-01, Alexander: keep the mix, label it): the colour label ([id^=custom-label-<section>-1], first paint "Mixed" from
   snippets/product-variant-picker.liquid) says "Mixed" while the selected pack's pairs differ and the colour name once they are all one colour
   (a swatch tap, or the shopper picking the same colour for every pair); the sticky bar reads the same state (snippets/bf26a-sticky-atc.liquid).
   r55 (F1-16): Shrine writes the pack price as "46.00" on a pack tap; the trailing .00 is dropped in the same task (MutationObserver, before paint),
   so the main price never shows "46.00" next to the server's "46". */
(function () {
  'use strict';
  if (window.__bf26r52) return;
  window.__bf26r52 = 1;

  function data(qb) {
    if (qb.__r52v) return qb.__r52v;
    var s = qb.querySelector('script[type="application/json"]');
    try { qb.__r52v = JSON.parse(s.textContent); } catch (e) { qb.__r52v = []; }
    return qb.__r52v;
  }
  function variant(qb, val) {
    var list = data(qb);
    for (var i = 0; i < list.length; i++) if (list[i].option1 === val) return list[i];
    return null;
  }
  /* Rollout guard: one option, 2+ variants, one shared price. Anything else is left to Shrine. */
  function safe(qb) {
    if (qb.__r52safe !== undefined) return qb.__r52safe;
    var list = data(qb), ok = list.length > 1;
    for (var i = 0; ok && i < list.length; i++) {
      if (list[i].option2 != null || list[i].option3 != null || list[i].price !== list[0].price) ok = false;
    }
    qb.__r52safe = ok;
    return ok;
  }
  function sized(src) { return src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=120'; }

  function setItem(qb, item, val, sync) {
    var s = item.querySelector('select');
    var v = variant(qb, val);
    if (!s || !v || !v.available) return;
    if (s.value !== val) s.value = val;
    if (s.value !== val) return; /* option missing or hidden */
    var same = !!sync && String(item.getAttribute('data-selected-id')) === String(v.id); /* r53: already rendered by Liquid */
    if (!same) item.setAttribute('data-selected-id', v.id);
    var img = item.querySelector('.quantity-break__selector-item__image img');
    if (!same && img && v.featured_image && v.featured_image.src) {
      var src = sized(v.featured_image.src);
      if (img.getAttribute('src') !== src) { img.setAttribute('src', src); img.alt = v.featured_image.alt || val; }
    }
    var card = item.closest('.quantity-break');
    var key = card && card.getAttribute('data-input');
    var idx = parseInt(item.getAttribute('data-select-index'), 10);
    if (qb.selectedVariants && key && qb.selectedVariants[key] && !isNaN(idx)) qb.selectedVariants[key][idx] = v.id;
  }
  function syncForm(qb) {
    var chk = qb.querySelector('input[name="quantity"]:checked');
    if (!chk || !qb.selectedVariants || !qb.selectedVariants[chk.getAttribute('data-input')]) return;
    var card = qb.querySelector('label[for="' + chk.id + '"]');
    if (card && card.querySelector('.quantity-break__selector-item')) qb.formVariants = qb.selectedVariants[chk.getAttribute('data-input')];
  }
  function items(card) { return card.querySelectorAll('.quantity-break__selector-item'); }

  function mix(qb) {
    if (qb.__r52mixed || !qb.selectedVariants || !safe(qb)) return;
    qb.__r52mixed = 1;
    qb.querySelectorAll('label.quantity-break').forEach(function (card) {
      var list = items(card);
      if (list.length < 2) return;
      var first = list[0].querySelector('select');
      if (!first) return;
      var order = [first.value];
      for (var i = 0; i < first.options.length; i++) {
        var o = first.options[i], v = variant(qb, o.value);
        if (order.indexOf(o.value) < 0 && !o.disabled && v && v.available) order.push(o.value);
      }
      for (var k = 1; k < list.length; k++) setItem(qb, list[k], order[k % order.length], true);
    });
    syncForm(qb);
  }

  /* r55: "Mixed" or the one colour of the selected pack's pairs. Exposed for the sticky bar. */
  function mixState(qb) {
    var chk = qb.querySelector('input[name="quantity"]:checked');
    var card = chk && qb.querySelector('label[for="' + chk.id + '"]');
    var sels = card ? card.querySelectorAll('.quantity-break__selector-item select') : [];
    if (sels.length < 2) return null;
    var vals = [];
    for (var i = 0; i < sels.length; i++) if (vals.indexOf(sels[i].value) < 0) vals.push(sels[i].value);
    return vals.length > 1 ? 'Mixed' : vals[0];
  }
  function label() {
    document.querySelectorAll('quantity-breaks').forEach(function (qb) {
      if (!safe(qb)) return;
      var t = mixState(qb), lab = document.getElementById('custom-label-' + qb.getAttribute('data-section') + '-1');
      if (!t || !lab) return;
      /* 22 Oct 2026: the colour label is a fixed invitation ("Pick your colours, mix and match", data-rk-static); only the class follows */
      if (!lab.hasAttribute('data-rk-static') && lab.textContent.trim() !== t) lab.textContent = t;
      var box = lab.closest('.product-form__input');
      if (box) box.classList.toggle('rk-mixed', t === 'Mixed');
    });
  }
  window.rkPackColour = function () { var qb = document.querySelector('quantity-breaks'); return qb && safe(qb) ? mixState(qb) : null; };

  function follow(val) {
    document.querySelectorAll('quantity-breaks').forEach(function (qb) {
      if (!safe(qb)) return;
      var v = variant(qb, val);
      if (!v || !v.available) return;
      qb.querySelectorAll('label.quantity-break').forEach(function (card) {
        items(card).forEach(function (it) { setItem(qb, it, val); });
      });
      syncForm(qb);
    });
    label();
  }

  /* r55: a tap on the swatch that is already checked fires no change event; while the pairs are mixed it still means "all this colour" */
  document.addEventListener('click', function (e) {
    var t = e.target, r = t && t.closest && t.closest('.color-swatch');
    var inp = r && r.querySelector('input[type="radio"]');
    if (!inp || !inp.checked || inp.disabled || !r.closest('.rk-mixed')) return;
    setTimeout(function () { if (inp.checked) follow(inp.value); }, 0);
  });
  /* r55: a pair or pack change (bubble phase, after Shrine's own handlers) keeps the label right */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('quantity-breaks')) return;
    if (t.matches('select') || t.name === 'quantity') setTimeout(label, 0);
  });
  /* r55 (F1-16): no ".00" after Shrine's pack price update */
  function strip(root) {
    var w = document.createTreeWalker(root, 4), n;
    while ((n = w.nextNode())) {
      var v = n.nodeValue;
      if (/\.00(?!\d)/.test(v)) { var nv = v.replace(/([$£€¥]\s?\d[\d,]*)\.00(?!\d)/g, '$1'); if (nv !== v) n.nodeValue = nv; }
    }
  }
  function watchPrices() {
    var first = document.querySelector('[id^="main-price-"]');
    var host = first && (first.closest('.product__info-wrapper, product-info, .product__info-container') || first.parentNode);
    if (!host || !window.MutationObserver) return;
    var SEL = '[id^="main-price-"], [id^="sticky-atc-separate-price-"]';
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var t = ms[i].target, el = t.nodeType === 1 ? t : t.parentNode, box = el && el.closest && el.closest(SEL);
        if (box) strip(box);
        else if (el && el.querySelectorAll) el.querySelectorAll(SEL).forEach(strip);
      }
    }).observe(host, { subtree: true, childList: true, characterData: true });
  }

  /* bubble phase on document: runs after Shrine's own variant-selects handler */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest || t.type !== 'radio') return;
    var vs = t.closest('variant-selects, variant-radios');
    if (!vs || vs.closest('quick-add-modal, [role="dialog"], cart-drawer')) return;
    follow(t.value);
  });

  function boot() {
    watchPrices();
    customElements.whenDefined('quantity-breaks').then(function () {
      document.querySelectorAll('quantity-breaks').forEach(mix);
      label();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
